import React from 'react';
import { Modal, BackdropBackgroundModes, VerticalPositionModes, Button } from '@nearpod-packages/core';
import classNames from 'classnames';
import styles from './DragAndDropGoldExclusive.scss.js';
import bannerShort from '../../../../assets/ThumbnailBanner/banner_short.png.js';
import { useCustomTranslation } from '../../../../hooks/useCustomTranslation/useCustomTranslation.js';

const DragAndDropGoldExclusive = _ref => {
  let {
    isOpen = true,
    containerRef
  } = _ref;
  const {
    tCustom
  } = useCustomTranslation();
  return /*#__PURE__*/React.createElement(Modal, {
    containerRef: containerRef,
    backdropBackground: BackdropBackgroundModes.whiteGradient,
    verticalPositionOnContainer: VerticalPositionModes.top,
    isOpen: isOpen,
    onClose: () => {},
    disableFocusTrap: true
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['modal-content']
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundImage: `url(${bannerShort})`
    },
    className: styles['modal-content__banner']
  }, /*#__PURE__*/React.createElement("p", {
    className: styles['modal-content__banner__text']
  }, " ", tCustom('UPGRADE_TO_EDIT'), " ")), /*#__PURE__*/React.createElement("h2", {
    className: classNames([styles['modal-content__title']])
  }, tCustom('TRY_DRAG_AND_DROP')), /*#__PURE__*/React.createElement("p", {
    className: classNames([styles['modal-content__description']])
  }, tCustom('DRAG_AND_DROP_DESCRIPTION')), /*#__PURE__*/React.createElement("div", {
    className: classNames([styles['modal-content__coupon']])
  }, /*#__PURE__*/React.createElement("p", {
    className: classNames([styles['modal-content__coupon__description']])
  }, tCustom('TRY_GOLD_COUPON_2')), /*#__PURE__*/React.createElement("p", {
    className: classNames([styles['modal-content__coupon__code']])
  }, tCustom('COUPON_CODE'))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles['modal-content__upgrade__cta']
  }, /*#__PURE__*/React.createElement(Button, {
    size: "size-big",
    fontWeight: "font-weight-light",
    bgColor: "background-blue",
    fontColor: "font-white",
    onClick: () => {
      // TODO: value to change the url based on domain if needed
      const pageToOpen = window.open('https://nearpod.com/pricing', '_blank');
      if (pageToOpen) {
        pageToOpen.focus();
      }
    }
  }, tCustom('UPGRADE'))), /*#__PURE__*/React.createElement("p", {
    className: classNames([styles['modal-content__upgrade__note']])
  }, tCustom('TRY_GOLD_COUPON_NOTE')))));
};
var DragAndDropGoldExclusive$1 = DragAndDropGoldExclusive;

export { DragAndDropGoldExclusive$1 as default };
//# sourceMappingURL=DragAndDropGoldExclusive.js.map
